export default __webpack_public_path__ + "static/media/chase_score.be51dbea.svg";